<form novalidate [formGroup]="editContactForm" (ngSubmit)="onSubmit()">
  <div class="grid-x align-center">
    <div class="cell large-4 medium-6 small-6">
      <label>Person's Full Name and/or Title:</label>
    </div>
    <div class="cell large-8 medium-6 small-6"><input formControlName="name" placeholder="Person's Full Name"
                                                      class="input-group-custom" maxlength="100">
      <label class="required-field">* Required Field</label>

      <div class="form-error is-visible" *ngIf="displayServerValidationError('name')">
        <span>{{displayServerValidationError('name')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="name"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x align-center">
    <div class="cell large-4 medium-6 small-6">
      <label>Organization Name:</label>
    </div>
    <div class="cell large-8 medium-6 small-6"><input formControlName="organizationName" placeholder="Organization Name"
                                                      class="input-group-custom" maxlength="100">
      <div class="form-error is-visible" *ngIf="displayServerValidationError('organizationName')">
        <span>{{displayServerValidationError('organizationName')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="organizationName"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-4 medium-6 small-6"><label>Postal Address:</label></div>
    <div class="cell large-8 medium-6 small-6"><textarea formControlName="streetAddress" placeholder="Street Address" style="margin-top: 0.25em"
                                                         class="input-group-custom"></textarea>
      <label class="required-field">* Required Field</label>
      <div class="form-error is-visible" *ngIf="displayAddressValidationError('streetAddress')">
        <span>{{displayAddressValidationError('streetAddress')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="streetAddress"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-4 medium-6 small-6"></div>
    <div class="cell large-8 medium-6 small-6"><input formControlName="city" placeholder="City"
                                                      class="input-group-custom" maxlength="50">
      <div class="form-error is-visible" *ngIf="displayAddressValidationError('city')">
        <span>{{displayAddressValidationError('city')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="city"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-4 medium-6 small-6"></div>
    <div class="cell large-8 medium-6 small-6"><input formControlName="state" placeholder="State"
                                                      class="input-group-custom" maxlength="50">
      <div class="form-error is-visible" *ngIf="displayAddressValidationError('state')">
        <span>{{displayAddressValidationError('state')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="state"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-4 medium-6 small-6"></div>
    <div class="cell large-8 medium-6 small-6"><input formControlName="postalCode" placeholder="Postal Code"
                                                      class="input-group-custom" maxlength="15">
      <div class="form-error is-visible" *ngIf="displayAddressValidationError('postalCode')">
        <span>{{displayAddressValidationError('postalCode')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="postalCode"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-4 medium-6 small-6"></div>
    <div class="cell large-8 medium-6 small-6">
      <div class="grid-x">

        <div class="cell">
          <select formControlName="countryName"
                  aria-describedby="Select a Country" (change)="showOtherElement()">
            <option *ngFor="let country of countries" [value]="country.countryCode"
                    [selected]="country.countryCode==this.editContactForm.getRawValue().countryName">
              {{country.countryName}}
            </option>
          </select>
          <label class="required-field">* Required Field</label>
        </div>
        <div class="cell" style="margin-top: 0.5rem"><input formControlName="otherCountry" placeholder="Other.."
                                                            *ngIf="showOtherCountryElement"
                                                            class="input-group-custom" maxlength="20"></div>
        <div class="form-error is-visible" *ngIf="displayValidationError('otherCountry')">
          <span *ngIf="this.editContactForm.get('otherCountry').errors.invalidValue">Invalid Value.</span>
        </div>
        <lib-whitelist-character-error [whitelistFormControl]="otherCountry"></lib-whitelist-character-error>
        <div class="cell form-error is-visible" *ngIf="displayAddressValidationError('countryName')">
          <span>{{displayAddressValidationError('countryName')}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="grid-x align-center">
    <div class="cell large-4 medium-6 small-6"><label>Phone Number:</label></div>
    <div class="cell large-8 medium-6 small-6"><input formControlName="phone" placeholder="e.g. +5 555-555-5555"
                                                      class="input-group-custom" maxlength="40">
      <label class="required-field">* Required Field</label>
      <div class="form-error is-visible" *ngIf="displayServerValidationError('phone')">
        <span>{{displayServerValidationError('phone')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="phone"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-4 medium-6 small-6"><label>Fax Number:</label></div>
    <div class="cell large-8 medium-6 small-6"><input formControlName="fax" placeholder="e.g. +5 555-555-5555"
                                                      class="input-group-custom" maxlength="40">
      <div class="form-error is-visible" *ngIf="displayServerValidationError('fax')">
        <span>{{displayServerValidationError('fax')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="fax"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x align-center">
    <div class="cell large-4 medium-6 small-6"><label>Email Address:</label></div>
    <div class="cell large-8 medium-6 small-6"><input formControlName="email" placeholder="Email Address"
                                                      class="input-group-custom" maxlength="100">
      <label class="required-field">* Required Field</label>
      <div class="form-error is-visible" *ngIf="displayValidationError('email')">
        <span *ngIf="this.editContactForm.get('email').errors.invalidEmail">Invalid Email.</span>
        <span *ngIf="this.editContactForm.get('email').errors.required">Please provide Email.</span>
      </div>
      <div class="form-error is-visible" *ngIf="displayServerValidationError('email')">
        <span>{{displayServerValidationError('email')}}</span>
      </div>
    </div>
  </div>
  <div class="grid-x save-cancel-button-group">
    <button class="iana-button-cancel" (click)="cancel()">{{newDelegation ? "Previous" : "Cancel"}}</button>
    <button class="iana-button"  [disabled]="!editContactForm.valid" type="submit">{{newDelegation ? "Next" : "Save"}}</button>
  </div>
</form>
